import React from "react";

const FeaturedByCompanies = () => {
  return (
    <div
      id="our-solutions"
      className="flex flex-col md:flex-row items-center justify-center bg-white py-12 md:py-32 px-4 md:px-10"
    >
      {/* Left: Image */}
      <div className="md:w-1/2 w-full ">
        <img
          src="/sec1Img.jpeg"
          alt="Team Working"
          className="md:-translate-y-20 w-full h-auto object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Right: Content Box */}
      <div className="md:translate-y-20  md:w-1/2 w-full bg-[#1C1C1C] text-white p-8 md:ml-[-80px] mt-8 md:mt-0 shadow-lg relative z-10">
        <p className="text-sm tracking-wide text-gray-400 mb-2">Our Solution</p>

        <h2 className="text-2xl md:text-2xl font-semibold leading-snug mb-4">
          <span className="inline-block w-1 h-6 bg-pink-500 mr-2 align-middle"></span>
          Hi Author 🙂
          <br />
          <p className="py-4">
            Ready to make your book a #1 Amazon Bestseller in just 12–16 days?
          </p>
        </h2>

        {/* <p className="text-sm mb-6">
          Have any Question ?{" "}
          <span className="font-semibold text-white">Get a free Guidebook</span>
        </p> */}

        {/* Checklist */}
        <ul className="space-y-3 text-sm">
          <li className="flex items-center">
            <span className="text-xl text-green-400 mr-2">✓</span>
            {/* Boost your book’s sales. */}✅ Increase sales & build strong
            credibility!
          </li>
          <li className="flex items-center">
            <span className="text-xl text-green-400 mr-2">✓</span>
            {/* Get Amazon #1 bestseller tag. */}✅ Earn the prestigious orange
            #1 Bestseller tag!
          </li>
          <li className="flex items-center">
            <span className="text-xl text-green-400 mr-2">✓</span>
            {/* Get Amazon #1 bestseller tag. */}
            💰 Fee: ₹43,631 — Best in the market!
          </li>
        </ul>
        <br />
        {/* <p>🔥 Limited-Time Offer – 60% OFF!</p>
        <p>Now only ₹17,452 (Valid for 2 days only)</p>
        <p>This exclusive deal won’t last — Act fast!</p>
        <p>Interested? Reply now and let’s get started!</p> */}

        {/* Divider */}
        <div className="mt-8 h-6 w-40">
          <svg
            viewBox="0 0 200 20"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
          >
            <path
              d="M0 10 C 10 0, 20 20, 30 10 
             S 50 0, 60 10 
             S 80 20, 90 10 
             S 110 0, 120 10 
             S 140 20, 150 10 
             S 170 0, 180 10 
             S 190 20, 200 10"
              stroke="#fff"
              fill="transparent"
              strokeWidth="2"
            />
          </svg>
        </div>
        <br />

        <p>If you are interested please leave a message on WhatsApp 🙂</p>
      </div>
    </div>
  );
};

export default FeaturedByCompanies;
